(() => {
  const modal = document.querySelector('[data-age-verification-modal]');

  if (!modal || modal.dataset.ageVerificationInitialized === 'true') return;

  modal.dataset.ageVerificationInitialized = 'true';

  const configElement = modal.querySelector('[data-age-verification-config]');
  if (!configElement) return;

  let config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Unable to read age verification settings.', error);
    return;
  }

  if (!config.enabled || config.designMode) return;

  const normalize = value => String(value || '').trim().toLowerCase();
  const normalizePath = path => {
    const normalizedPath = String(path || '/').replace(/\/{2,}/g, '/');
    return normalizedPath !== '/' ? normalizedPath.replace(/\/$/, '') : normalizedPath;
  };
  const currentPath = normalizePath(window.location.pathname);
  const exemptRules = String(config.exemptUrls || '')
    .split(/[\n,]+/)
    .map(rule => rule.trim())
    .filter(Boolean)
    .map(rule => {
      try {
        const wildcard = rule.endsWith('*');
        const path = normalizePath(new URL(rule, window.location.origin).pathname.replace(/\*$/, ''));
        return wildcard ? `${path}*` : path;
      } catch (error) {
        const wildcard = rule.endsWith('*');
        const path = normalizePath(rule.split(/[?#]/)[0].replace(/\*$/, ''));
        return wildcard ? `${path}*` : path;
      }
    });

  const isExempt = exemptRules.some(rule => {
    if (rule.endsWith('*')) return currentPath.startsWith(rule.slice(0, -1));
    return currentPath === rule;
  });

  if (isExempt) return;

  const modalContent = modal.querySelector('[data-content]');
  const storageKey = `modal-${window.location.hostname}-${modal.id}`;
  const contentKey = modalContent ? modalContent.textContent.trim() : 'age-verification';
  const frequencySeconds = {
    day: 86400,
    week: 604800,
    month: 2419200,
    year: 31536000,
  };

  const hasValidConfirmation = () => {
    try {
      const storedValue = JSON.parse(localStorage.getItem(storageKey));
      if (!storedValue || storedValue.content !== contentKey) return false;

      const elapsedSeconds = (Date.now() - Number(storedValue.shown)) / 1000;
      return elapsedSeconds <= (frequencySeconds[config.frequency] || frequencySeconds.month);
    } catch (error) {
      return false;
    }
  };

  if (hasValidConfirmation()) return;

  const restrictedType = normalize(config.restrictedProductType);
  const restrictedTag = normalize(config.restrictedProductTag);
  let hasShown = false;

  const productElementIsRestricted = element => {
    const productType = normalize(element.dataset.productType);
    const productTags = String(element.dataset.productTags || '')
      .split('|')
      .map(normalize);

    return Boolean(
      (restrictedType && productType === restrictedType) ||
      (restrictedTag && productTags.includes(restrictedTag))
    );
  };

  const pageContainsRestrictedProduct = () =>
    Boolean(config.initialRestrictedProduct) ||
    Array.from(document.querySelectorAll('[data-product-type], [data-product-tags]'))
      .some(productElementIsRestricted);

  const showWhenReady = async () => {
    if (hasShown || !pageContainsRestrictedProduct()) return;

    hasShown = true;
    await customElements.whenDefined('modal-box');
    modal.show();
  };

  const confirmButton = modal.querySelector('[data-age-verification-confirm]');
  if (confirmButton) {
    confirmButton.addEventListener('click', () => {
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          shown: Date.now(),
          content: contentKey,
        }));
      } catch (error) {
        // Continue even when storage is unavailable; the visitor can still use the site.
      }

      modal.hide(false);
    });
  }

  showWhenReady();

  const observer = new MutationObserver(showWhenReady);
  observer.observe(document.body, { childList: true, subtree: true });
})();
